exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Hide scrollbar for Chrome, Safari and Opera */\n/* .overflow-y-auto::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE, Edge and Firefox */\n/* .overflow-y-auto {\n  -ms-overflow-style: none; \n  scrollbar-width: none;  \n} */\n", ""]);

// exports
